var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showMask)?_c('FullSwiper',{on:{"showFullSwiper":_vm.showFullSwiper}}):_vm._e(),_c('router-view',{on:{"showFullSwiper":_vm.showFullSwiper}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }